const HOUR_MILLIS = 60 * 60 * 1000;
const MINUTE_MILLIS = 60 * 1000;
const SECOND_MILLIS = 1000;
const THRESHOLD_MILLIS = 48 * HOUR_MILLIS;

const pad = (number) => {
    if (number < 10) {
        return '0' + number;
    }
    
    return '' + number;
};

export const getCountdownTime = (endTimeString) => {
    if (endTimeString === null) {
        return null;
    }

    const now = new Date();
    const endTime = new Date(endTimeString.replace(" ", "T"));

    if (endTime.getTime() <= now.getTime()) {
        return null;
    }

    const countdownMillis =  endTime.getTime() - now.getTime();

    if (countdownMillis > THRESHOLD_MILLIS) {
        return null;
    }

    return countdownMillis;
};

export const getCountdown = (countdownTime) => {
    let remainTime = countdownTime;

    const hours = Math.floor(remainTime / HOUR_MILLIS);
    remainTime = remainTime - hours * HOUR_MILLIS;

    const minutes = Math.floor(remainTime / MINUTE_MILLIS);
    remainTime = remainTime - minutes * MINUTE_MILLIS;

    const seconds = Math.floor(remainTime / SECOND_MILLIS);

    return {
        hours: pad(hours),
        minutes: pad(minutes),
        seconds: pad(seconds)
    };
};
